import { render, staticRenderFns } from "./DiskUsbChart.vue?vue&type=template&id=f94d627c&scoped=true&"
import script from "./DiskUsbChart.vue?vue&type=script&lang=js&"
export * from "./DiskUsbChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94d627c",
  null
  
)

export default component.exports